// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertError: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9,18 C13.9717742,18 18,13.9717742 18,9 C18,4.02822581 13.9717742,0 9,0 C4.02822581,0 0,4.02822581 0,9 C0,13.9717742 4.02822581,18 9,18 Z M11.358871,13.412889 L9,11.0322581 L6.63751418,13.412889 C6.46694257,13.5834607 6.19111486,13.5834607 6.02057869,13.412889 L4.58711095,11.9758065 C4.41653935,11.8052348 4.41653935,11.5294426 4.58711095,11.358871 L6.96774194,9 L4.58711095,6.63751418 C4.41653935,6.46694257 4.41653935,6.19111486 4.58711095,6.02057869 L6.02419355,4.58346065 C6.19476515,4.41288905 6.47055743,4.41288905 6.64112903,4.58346065 L9,6.96774194 L11.3624858,4.58711095 C11.5330574,4.41653935 11.8088851,4.41653935 11.9794213,4.58711095 L13.4165393,6.02419355 C13.587111,6.19476515 13.587111,6.47055743 13.4165393,6.64112903 L11.0322581,9 L13.412889,11.3624858 C13.5834607,11.5330574 13.5834607,11.8088851 13.412889,11.9794213 L11.9758065,13.412889 C11.8052348,13.5834607 11.5294426,13.5834607 11.358871,13.412889 Z"
            />
        </svg>
    );
};

export default React.memo(AlertError);
